import { SubAPI } from "./SubAPI";
export class PriceSectionNotes extends SubAPI {
    list(props) { return this.fetcher.get("/api/price-section-notes", props); }
    upsert(props) { return this.fetcher.post("/api/price-section-note", props); }
    setDefaults(input) { return this.fetcher.post("/api/price-section-note/defaults", input); }
    getDefaults(props) { return this.fetcher.get("/api/price-section-note/defaults", props); }
}
